<template lang="pug">
AppMobileTopBar
AppMainMenu
router-view
       //- views render here
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import {
  defineComponent, computed, onBeforeUnmount, watch,
} from 'vue';
import { useRoute } from 'vue-router';

import AppMainMenu from '@/components/AppMainMenu.vue';
import AppMobileTopBar from '@/components/AppMobileTopBar.vue';
import { useMobileTableCards } from '@/composables/useMobileTableCards';
import { useScrollableTabs } from '@/composables/useScrollableTabs';
import { isWebAppPath } from '@/utils/webAppRoutes';

export default defineComponent({
  name: 'DashView',
  components: { AppMainMenu, AppMobileTopBar },
  computed: {
    ...mapGetters('shared', ['isMainMenuCollapsed']),
  },
  setup() {
    const route = useRoute();
    useMobileTableCards();
    useScrollableTabs();

    const isWebRoute = computed(() => isWebAppPath(route.path));

    // The web app also renders inside this layout, so pick the body theme by route:
    // CMS pages get the CMS theme, web app pages keep their own look (see _web-theme.scss).
    watch(isWebRoute, (isWeb) => {
      document.body.classList.toggle('cms-theme', !isWeb);
      document.body.classList.toggle('web-theme', isWeb);
    }, { immediate: true });
    onBeforeUnmount(() => document.body.classList.remove('cms-theme', 'web-theme'));

    return {
      isWebRoute,
    };
  },
});
</script>
